import { PROFILE_TYPE } from 'domain/value-objects/profile-type';

export enum ReportType {
  pdf = 'pdf',
  excel = 'xlsx',
  json = 'json',
  csv = 'csv',
}

export interface ReportRadinoParams {
  endsAt: string;
  startsAt: string;
  semesterIds?: string[];
  courseHashIds: string[];
  roleIds: PROFILE_TYPE | string[];
  organizationHashIds: string[];
  type: ReportType;
}
